// import './index.css';

import('./App').then(async ({ startApp }) => {
  return startApp();
});
